/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Query, Mutation } from 'react-apollo'
import gql from 'graphql-tag'

import {
  InfoSidebar,
  CaseRelations,
  FileView,
  Modal,
  SvgIcon,
  Button,
  Warning,
  ObjectFiles
} from '../'

import { RelatedObject } from './RelatedObject'

import {
  decodeBase64
} from '../../utils'

const QUERY_FILERELATIONS = gql`
  query($file: UUID!) {
    filerelations(file_Id: $file) {
      edges {
        node {
          id
          objectId
        }
      }
    }
  }
`

const MUTATION_FILERELATION_DELETE = gql`
  mutation($input: FileRelationDeleteInput!) {
    filerelationDelete(input: $input) {
      outcome
    }
  }
`


class CaseSidebar extends React.PureComponent {
  static propTypes = {
    caseId: PropTypes.string.isRequired,
    caseAffectsIdentity: PropTypes.object.isRequired,
    caseProductType: PropTypes.string,
    caseRequestType: PropTypes.string,
    caseReviewed: PropTypes.bool,
    saveCase: PropTypes.func.isRequired
  }

  state = {
    viewFile: null,
    chooseFileToAttach: false,
    fileUploadFail: false,
    fileDetachSuccess: false,
    fileDetachFail: false,
    fileUploadOrDetached: null,
    triggerObjectFileRefetch: null
  }

  handleFileDownload = () => {
    let file = this.state.viewFile
    let filenameToSaveAs = file.asset.split('__').pop()
    let a = document.createElement('a')
    a.href = file.url
    a.download = filenameToSaveAs  // NOTE: make sure rename happens (currently only honored for links to resources with the same-origin)
    a.onclick = (e) => document.body.removeChild(e.target)
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
  }

  detachFileFromCase = (filerelationDelete, fileRelationId) => {
    let input = {
      id: fileRelationId
    }

    filerelationDelete({ variables: { input } })
    .then(({ data }) => {
      data.filerelationDelete.outcome
        ? console.log('File relation successfully removed.')
        : console.log('Removal of file relation not possible since invalid id was provided')
      this.setState({ fileDetachSuccess: true, triggerObjectFileRefetch: fileRelationId })
    })
    .catch((error) => {
      console.log('Removal of file relation failed', error)
      this.setState({ fileDetachFail: true })
    })
  }

  render() {
    return (
      <div className={this.props.className}>
        <InfoSidebar
          header={<h2 className='u-text-caps'>Related items</h2>}
          body={[
            <div className='slds-size_1-of-1 slds-m-top_large'>
              <CaseRelations caseId={this.props.caseId}>
                {(objectId, contentTypeModel) => (
                  objectId && contentTypeModel
                    ? <RelatedObject
                        objectUuid={objectId}
                        contentTypeModel={contentTypeModel}
                        key={objectId}
                      />
                    : 'Unknown relation'
                )}
              </CaseRelations>
              <ObjectFiles
                object={this.props.caseId}
                renderAs='list'
                triggerRefetch={this.state.triggerObjectFileRefetch}
                onClick={fileObj => this.setState({ viewFile: fileObj })}
              />
            </div>
          ]}
        />
        {this.state.viewFile &&
          <Modal
            heading='View file'
            body={
              this.state.fileDetachSuccess
                ? <div className='slds-text-align_center'>
                    <SvgIcon
                      variant='utility'
                      symbol='check'
                      colour='success'
                      className='slds-m-right_small'
                    />
                    File detached successfully.
                  </div>
                : this.state.fileDetachFail
                  ? <Warning className='slds-text-align_center'>
                      File detachment failed!
                    </Warning>
                  : <FileView file={this.state.viewFile} />
            }
            footer={
              <div className='slds-text-align_center'>
                <Button
                  onClick={() => this.setState({
                    viewFile: null,
                    fileDetachFail: false,
                    fileDetachSuccess: false,
                  })}>
                  Close
                </Button>
                <Button onClick={this.handleFileDownload} disabled={this.state.fileDetachSuccess}>
                  Download
                </Button>
                <Query query={QUERY_FILERELATIONS} variables={{ file: decodeBase64(this.state.viewFile.id) }}>
                  {({ loading, error, data }) => {
                    if (loading || error) {
                      return null
                    }
                    let fileRelation = data.filerelations.edges[0]
                    return (
                      <Mutation mutation={MUTATION_FILERELATION_DELETE}>
                        {filerelationDelete => (
                          <Button
                            onClick={() => this.detachFileFromCase(filerelationDelete, fileRelation ? fileRelation.node.id : null)}
                            disabled={fileRelation === null || this.state.fileDetachSuccess}>
                            Detach from case
                          </Button>
                        )}
                      </Mutation>
                    )
                  }}
                </Query>
              </div>
            }
            sizeLarge={true}
          />
        }
      </div>
    )
  }
}

export default withRouter(CaseSidebar)



// WEBPACK FOOTER //
// ./src/components/case-sidebar/index.js